import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/exam';
import { ISetAddExam, ISetDeleteExam, ISetExamMessages } from '../../models/action/exam';
import { ExamEntryDateType } from '../../models/enums/ExamEntryDateType';
import { ExamScoringType } from '../../models/enums/ExamScoringType';

const _logger = Log.create('Exam Reducer');

const addExamSetActivity = (newState: any, examPageAction: any) => {

    const examEntryDateType: any = examPageAction?.examEntryDateType ?? '0';
    const refCustomProperty4: any = examPageAction?.customProperty4 ?? 'false';
    const refIsUseExamSecurity: any = examPageAction && examPageAction.examExternalSecurityProfile !== '';

    newState.ExamData = {
        activityId: examPageAction ? examPageAction.activityId : '',
        abbreviation: examPageAction ? examPageAction.abbreviation : '',
        name: examPageAction ? examPageAction.name : '',
        allowDownload: examPageAction ? examPageAction.allowDownload : false,
        description: examPageAction ? examPageAction.description : '',
        isCommon: examPageAction?.isCommon ? 1 : 0,
        dateCriteria: examPageAction ? examPageAction.dateCriteria : 0,
        datePrerequisiteActivityHours: examPageAction?.datePrerequisiteActivityHours ?? '',
        datePrerequisiteActivityId: examPageAction?.datePrerequisiteActivityId ? [examPageAction?.datePrerequisiteActivityId] : '',
        prerequisiteActivityId: examPageAction?.prerequisiteActivityId ? examPageAction?.prerequisiteActivityId : '',
        completionType: examPageAction?.completionType ?? 1,
        completionCriteria: examPageAction?.completionCriteria,
        alwaysOnTop: examPageAction?.alwaysOnTop,
        dateRange: '',
        fileInputKey: '',
        photoUploadKey: '',
        activityConditionalBeginDate: examPageAction?.beginDate,
        activityConditionalEndDate: examPageAction?.endDate,
        termWeekIds: examPageAction?.termWeekIds,
        selectedActivityOwnersTagIds: examPageAction?.selectedActivityOwnersTagIds,
        selectedActivityUnitsTagIds: examPageAction?.selectedActivityUnitsTagIds,
        selectedClass: examPageAction?.selectedClass,
        allUnits: examPageAction?.allUnits,
        courseId: examPageAction?.courseId,
        examPreMessage: examPageAction?.examPreMessage,
        examPostMessage: examPageAction?.examPostMessage,
        repeatCount: examPageAction?.repeatCount,
        examRepeatCountInfinity: examPageAction?.examRepeatCountInfinity,
        examScoringType: examPageAction?.examScoringType,
        examQuestionWeights: examPageAction?.examQuestionWeights ?? [],
        isRandomChoice: examPageAction?.isRandomChoice,
        isRandomQuestion: examPageAction?.isRandomQuestion,
        autoEnroll: examPageAction?.autoEnroll,
        cardImgName: examPageAction?.cardImgName,
        examDurationInMinutes: examPageAction?.examDurationInMinutes,
        examCategoryId: examPageAction?.examCategoryId,
        examShowAnswerSpecifiedDate: examPageAction?.examShowAnswerSpecifiedDate,
        examQuestionCount: examPageAction?.examQuestionCount,
        examQuestionWeightingType: examPageAction?.examQuestionWeightingType,
        // tslint:disable-next-line: radix
        examEntryDateType: parseInt(examEntryDateType), // CustomProperty2
        showQuestionScoreInExam: examPageAction?.showQuestionScoreInExam,
        allowStudentToSeeExamReport: examPageAction?.allowStudentToSeeExamReport,
        customProperty4: refCustomProperty4 === 'true',
      //  customProperty5: examPageAction && examPageAction.customProperty5,
        showStudentReportAfterFirstAttempt: examPageAction?.showStudentReportAfterFirstAttempt,
        showStudentOnlyExamPoints: examPageAction?.showStudentOnlyExamPoints,
        examSessionEndDate: examPageAction?.examSessionEndDate,
        examSessionBeginDate: examPageAction?.examSessionBeginDate,
        isUseExamExternalSecurity :  refIsUseExamSecurity,
        examExternalSecurityProfile: examPageAction?.examExternalSecurityProfile,
        learningOutcomeId: examPageAction?.learningOutcomeId,
    };
}

const examReducer = (state = GlobalState().exam, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {...state};
    if (action.type === Actions.actions.SET_EXAM_DATA_DEFAULT) {
        newState.ExamData = {
            isUpdate: false,
            isCommon: 0,
            name: '',
            description: '',
            filterActivityView: 'criterionDate',
            dateRange: '',
            selectActivity: [],
            note: 0,
            allUnits: false,
            selectUnits: [],
            selectCondition: [],
            selectOwner: [],
            completionType: 3,
            alwaysOnTop: false,
            selectedClass: [],
            activitytype: '5',
            selectWeek: [],
            termWeekIds: [],
            activityTime: 0,
            selectedActivityUnitsTagIds: [],
            selectedActivityOwnersTagIds: [],
            prerequisiteActivityId: '',
            datePrerequisiteActivityId: '',
            examPreMessage: '',
            examPostMessage: '',
            repeatCount: 1,
            examRepeatCountInfinity: false,
            examEntryDateType: ExamEntryDateType.LoginWithinGivenTime, // CustomProperty2
            examScoringType: ExamScoringType.LastAttempt,
            examQuestionWeights: [],
            isRandomChoice: true,
            isRandomQuestion: true,
            autoEnroll: true,
            cardImgName: '',
            dateCriteria:0,
            examCategoryId: '',
            learningOutcomeId: null,
        };
    }
    if (action.type === Actions.actions.ADD_EXAM_SET_ACTIVITY) {
        const examPageActionPayload = (action as unknown) as ISetAddExam;
        const examPageAction = examPageActionPayload?.examData ? examPageActionPayload.examData[0] : null;
        addExamSetActivity(newState, examPageAction);
    }
    if (action.type === Actions.actions.DELETE_EXAM_SET_ACTIVITY) {
        const examPageAction = action as ISetDeleteExam;
        newState.exam.deleteExamStatus = examPageAction.deleteExamStatus;
    }
    if (action.type === Actions.actions.SET_EXAM_MESSAGES) {
        const examPageAction = action as ISetExamMessages;
        newState.ExamData.examPreMessage = examPageAction.setExamMessagesModel?.defaultExamPreMessage;
        newState.ExamData.examPostMessage = examPageAction.setExamMessagesModel?.defaultExamPostMessage;
    }
    return Object.assign({}, state, newState);
};

export default examReducer;
